<template>
  <div class="market-overview">
    <head-title class="head-title">
      Currencies & Market&nbsp;Overview
    </head-title>
    <table class="table-top">
      <tr class="table-top__tr">
        <td class="td table-top__td">
          <div class="td__name">Total market cap</div>
          <div class="td__value-container">
            <div class="td__value">{{totalMarketCap | getValueForCurrencyCode(currencyCode) | formatMoney(currencyCode)}}</div>
            <div class="td__chart-percent-container">
              <div class="td__difference">
                <percent-trend :value="totalMarketCapPercentChange | getValueForCurrencyCode(currencyCode)"/>
              </div>
              <graph-el :src="`/images/global/sparkline/total_market_cap/${currencyCode}/preview.svg?color=D0000A`" class="td__graph"/>
            </div>
          </div>
        </td>
        <td class="td table-top__td">
          <div class="td__name">Total 24h trading volume</div>
          <div class="td__value-container">
            <div class="td__value">{{totalVolume24h | getValueForCurrencyCode(currencyCode) | formatMoney(currencyCode)}}</div>
            <div class="td__chart-percent-container">
              <div class="td__difference">
                <percent-trend :value="totalMarketVolumePercentChange | getValueForCurrencyCode(currencyCode)"/>
              </div>
              <graph-el :src="`/images/global/sparkline/total_volume24h/${currencyCode}/preview.svg?color=D0000A`" class="td__graph"/>
            </div>
          </div>
        </td>
        <td class="td table-top__td">
          <div class="td__name">Currencies</div>
          <div class="td__amount">{{totalRowsCount}}</div>
          <div class="td__addedCurrencies" v-if="showCountNewCurrencies">{{numberNewCurrencies}}</div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { apiUrl } from 'src/utils/config';
import { formatMoney, getValueForCurrencyCode } from 'src/utils/helpers';

export default {
  filters: {
    formatMoney,
    getValueForCurrencyCode,
  },
  computed: {
    ...mapState('tickers', [
      'totalRowsCount',
      'totalMarketCap',
      'totalMarketCapPercentChange',
      'totalMarketVolumePercentChange',
      'totalVolume24h',
      'numberNewCurrencies',
    ]),
    ...mapGetters('userData', ['currencyCode']),
    showCountNewCurrencies() {
      return this.numberNewCurrencies > 0;
    },
    apiUrl: () => apiUrl,
  },
};
</script>

<style lang="scss" scoped>
.market-overview {
  margin: 60px auto 0;
  background: $white-color2;
  max-width: 964px;
  width: 100%;
  border-radius: 5px;
  background: $white-color2;
  padding: 30px 0 0;
}

.head-title {
  margin-left: 29px;
  margin-bottom: 33px;
}
.td {
  &__name {
    @include font(12px, $grey-color1);
    font-weight: 500;
    margin-bottom: 9px;
  }
  &__graph {
    width: 65px;
    height: 20px;
    vertical-align: top;
    margin-top: 1px;
  }
  &__chart-percent-container {
    display: inline-flex;
    max-width: 168px;
    min-width: 160px;
    justify-content: space-between;
    align-items: center;
    height: 24px;
  }
  &__difference {
    @include font(13px);
    font-weight: 500;
    display: inline-block;
    vertical-align: top;
    .value {
      position: relative;
      margin-left: 2px;
      @include valueLabel;
      &_red {
        &:before {
          background: $red-color3;
        }
      }
      &_green {
        &:before {
          background: $green-color1;
        }
      }
    }
  }
  &__value-container {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
  }
  &__value {
    @include font(17px);
    line-height: 27px;
    font-weight: 500;
    margin-right: 4px;
    display: inline-block;
  }
  &__amount {
    @include font(17px);
    line-height: 27px;
    font-weight: 500;
    display: inline-block;
    margin-top: 2px;
  }
  &__addedCurrencies {
    @include font(13px, $green-color1, 500);
    position: relative;
    display: inline-block;
    margin-left: 12px;
    vertical-align: top;
    margin-top: 8px;
    @include valueLabel;
    &:before {
      background: $green-color1;
    }
    &:after {
      position: absolute;
      left: -8px;
      content: '+';
    }
  }
}
.table-top {
  width: 100%;
  border-collapse: collapse;
  &__td {
    vertical-align: top;
    padding: 37px 31px 31px;
    border-top: 1px solid $grey-color3;
    &:first-child {
      width: 39.3%;
      border-right: 1px solid $grey-color3;
    }
    &:nth-child(2) {
      border-right: 1px solid $grey-color3;
      width: 39.4%;
    }
    &:last-child {
      width: 39.3%;
    }
  }
}

  /* Large Devices, Wide Screens */
  @media only screen and (max-width : 1440px) {

  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width : 1280px) {

  }

  /* Small Devices, Tablets */
  @media only screen and (max-width : 1024px) {
    .market-overview {
      width: calc(100% - 20px);
    }
    .td {
      &__name {
        margin-bottom: 14px;
      }
      &__chart-percent-container {
        flex-direction: row-reverse;
      }
    }
  }
  /* Extra Small Devices, Phones */
  @media only screen and (max-width : 768px) {

  }

  @media only screen and (max-width : 700px) {
    .table-top {
      &__tr {
        display: flex;
        flex-direction: column;
      }
      &__td {
        &#{&} { // increase specificity
          text-align: center;
          padding: 27px 19px 24px;
          &:not(:last-of-type) {
            padding-bottom: 22px;
          }
          width: 100%;
          border-right: none;
          &:first-of-type {
            border-top: none;
          }
          &__value {
            margin-right: 40px;
          }
          .td__value-container {
            height: auto;
            justify-content: center;
            align-items: center;
          }
          .td__chart-percent-container {
            margin-top: 13px;
          }
          .td__value-container {
            flex-direction: column;
          }
        }
      }
    }
    .market-overview {
      margin-top: 40px;
      padding-top: 27px;
      max-width: 400px;
    }
    .head-title {
      margin-bottom: 1px;
      text-align: center;
      max-width: 267px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media only screen and (max-width : 700px) and (min-width: 401px) {
    .table-top__td {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width : 400px) {
    .market-overview {
      margin-top: 10px;
    }
    .td__value {
      margin-right: 40px;
    }
    .head-title {
      margin-left: 16px;
      text-align: left;
    }
    .table-top {
      &__td {
        &#{&} { // increase specificity
          text-align: left;
        }
      }
    }
    .td__value-container {
      &#{&}#{&} { // increase specificity
        align-items: flex-start;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/currenciesTable/MarketOverview.vue